/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Info/DateAt
 * @desc Showing experiment.date_at + allow for update
 */

import { FormShowEditDateContainer as FormShowEditDate } from 'labstep-web/core/Form/ShowEdit/Date';
import type React from 'react';
import type { ExperimentWorkflowInfoDateAtProps } from './types';

export const ExperimentWorkflowInfoDateAt: React.FC<
  ExperimentWorkflowInfoDateAtProps
> = ({
  experimentWorkflow,
  label,
  field,
  dateTimePickerOptions,
  popup,
}) => {
  return (
    <FormShowEditDate
      dataCy={'components/ExperimentWorkflow/Info/DateAt'}
      entity={experimentWorkflow}
      field={field}
      label={label}
      dateTimePickerOptions={dateTimePickerOptions}
      popup={popup}
    />
  );
};
